import { VyIcon } from '@weft/icons';
import { withDefault } from '@weft/utils';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { VyTableToolbar } from '../../../../../../components/new-design/table/vy-table-toolbar/vy-table-toolbar';
import { useDialog } from '../../../../../../hooks/use-dialog';
import { useSearchWithSearchParams } from '../../../../../../hooks/use-search-with-search-params';
import { ContractsFilterDrawer } from '../../ContractsFilterDrawer';

export const ContractsTableToolbar: React.FC = () => {
  const [query, setQuery] = useSearchWithSearchParams();
  const { isDialogOpen: isFilterDrawerOpen, handleOpen: openFilterDrawer, handleClose: closeFilterDrawer } = useDialog();

  return (
    <VyTableToolbar>
      <VyTableToolbar.Queries>
        <VyTableToolbar.SearchInput
          onChange={(event) => setQuery(event.target.value)}
          defaultValue={withDefault(query, '')}
        />
      </VyTableToolbar.Queries>

      <VyTableToolbar.Actions>
        <>
          <VyTableToolbar.FilterButton
            onClick={openFilterDrawer}
          />

          <ContractsFilterDrawer
            open={isFilterDrawerOpen}
            onClose={closeFilterDrawer}
          />
        </>

        <VyTableToolbar.CtaButton
          sx={{ columnGap: '12px' }}
          component={NavLink}
          to="create"
        >
          <VyIcon icon="PlusMedium"/>
          Create
        </VyTableToolbar.CtaButton>
      </VyTableToolbar.Actions>
    </VyTableToolbar>
  );
};